/**
 * Puremer Cart JavaScript
 * Clean cart functionality with Ajax updates
 */

console.log('=== PUREMER CART JS FILE LOADED ===');
console.log('Current URL:', window.location.href);
console.log('Document ready state:', document.readyState);

(function() {
  'use strict';

  // Cart state management
  const PuremerCart = {
    
    // Initialize cart functionality
    init() {
      console.log('PuremerCart: Initializing cart functionality...');
      
      this.cartForm = document.getElementById('cart-form');
      this.loadingOverlay = document.querySelector('[data-cart-loading]');
      
      console.log('PuremerCart: Cart form found:', this.cartForm);
      console.log('PuremerCart: Loading overlay found:', this.loadingOverlay);
      
      if (!this.cartForm) {
        console.log('PuremerCart: Cart form not found, exiting...');
        return;
      }
      
      this.bindEvents();
      this.initQuantitySelectors();
      this.initRemoveButtons();
      
      console.log('PuremerCart: Initialization complete');
      window.PuremerCartInitialized = true;
    },

    // Bind form events
    bindEvents() {
      // Prevent default form submission for quantity changes
      this.cartForm.addEventListener('submit', (e) => {
        const submitButton = e.submitter;
        if (submitButton && submitButton.name === 'checkout') {
          // Allow normal checkout
          return true;
        }
        e.preventDefault();
      });
    },

    // Initialize quantity selectors
    initQuantitySelectors() {
      const quantityContainers = document.querySelectorAll('.puremer-quantity');
      
      console.log('PuremerCart: Found quantity containers:', quantityContainers.length);
      
      quantityContainers.forEach((container, index) => {
        console.log(`PuremerCart: Initializing quantity container ${index + 1}`);
        
        const minusBtn = container.querySelector('[data-quantity-minus]');
        const plusBtn = container.querySelector('[data-quantity-plus]');
        const input = container.querySelector('[data-quantity-input]');
        
        console.log('PuremerCart: Elements found - minus:', !!minusBtn, 'plus:', !!plusBtn, 'input:', !!input);
        
        if (!input) {
          console.log('PuremerCart: No input found, skipping container');
          return;
        }
        
        // Minus button
        if (minusBtn) {
          minusBtn.addEventListener('click', (e) => {
            console.log('PuremerCart: Minus button clicked');
            e.preventDefault();
            const currentValue = parseInt(input.value) || 0;
            if (currentValue > 0) {
              input.value = currentValue - 1;
              this.updateQuantity(input);
            }
          });
        }
        
        // Plus button
        if (plusBtn) {
          plusBtn.addEventListener('click', (e) => {
            console.log('PuremerCart: Plus button clicked');
            e.preventDefault();
            const currentValue = parseInt(input.value) || 0;
            input.value = currentValue + 1;
            this.updateQuantity(input);
          });
        }
        
        // Direct input change
        let debounceTimer;
        input.addEventListener('change', () => {
          console.log('PuremerCart: Input changed');
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            this.updateQuantity(input);
          }, 500);
        });
      });
    },

    // Initialize remove buttons
    initRemoveButtons() {
      const removeButtons = document.querySelectorAll('[data-remove-item]');
      
      console.log('PuremerCart: Found remove buttons:', removeButtons.length);
      
      removeButtons.forEach((button, index) => {
        console.log(`PuremerCart: Initializing remove button ${index + 1}, variant ID:`, button.dataset.variantId);
        
        button.addEventListener('click', (e) => {
          console.log('PuremerCart: Remove button clicked');
          e.preventDefault();
          const variantId = button.dataset.variantId;
          console.log('PuremerCart: Removing variant ID:', variantId);
          if (variantId) {
            this.removeItem(variantId);
          }
        });
      });
    },

    // Update quantity via Ajax
    updateQuantity(input) {
      const quantity = parseInt(input.value) || 0;
      const cartItem = input.closest('[data-cart-item]');
      const variantId = cartItem ? cartItem.dataset.variantId : null;
      
      console.log('PuremerCart: updateQuantity called - quantity:', quantity, 'variantId:', variantId);
      console.log('PuremerCart: cartItem:', cartItem);
      
      if (!variantId) {
        console.error('PuremerCart: No variant ID found');
        return;
      }
      
      if (quantity < 0) {
        input.value = 0;
        return;
      }
      
      this.showLoading();
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);
      
      fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(cart => {
        this.updateCartUI(cart);
        if (quantity === 0) {
          // Remove item from DOM if quantity is 0
          cartItem.style.opacity = '0';
          setTimeout(() => {
            cartItem.remove();
            // Check if cart is empty
            if (cart.item_count === 0) {
              window.location.reload();
            }
          }, 300);
        } else {
          // Update the line total for this item
          const lineTotal = cartItem.querySelector('[data-line-total]');
          if (lineTotal) {
            const item = cart.items.find(item => item.variant_id == variantId);
            if (item) {
              lineTotal.textContent = this.formatMoney(item.final_line_price);
            }
          }
        }
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        this.showError('カートの更新中にエラーが発生しました');
        // Reset input value on error
        input.value = input.defaultValue;
      })
      .finally(() => {
        this.hideLoading();
      });
    },

    // Remove item from cart
    removeItem(variantId) {
      console.log('PuremerCart: removeItem called - variantId:', variantId);
      this.showLoading();
      
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '0');
      
      fetch('/cart/change.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(cart => {
        // Remove item from DOM
        const item = document.querySelector(`[data-cart-item][data-variant-id="${variantId}"]`);
        if (item) {
          item.style.opacity = '0';
          setTimeout(() => {
            item.remove();
            this.updateCartUI(cart);
            
            // Check if cart is empty
            if (cart.item_count === 0) {
              window.location.reload();
            }
          }, 300);
        } else {
          // If item not found in DOM, just update UI
          this.updateCartUI(cart);
          if (cart.item_count === 0) {
            window.location.reload();
          }
        }
      })
      .catch(error => {
        console.error('Error removing item:', error);
        this.showError('商品の削除中にエラーが発生しました');
      })
      .finally(() => {
        this.hideLoading();
      });
    },

    // Update cart UI elements
    updateCartUI(cart) {
      // Update subtotal
      const subtotalElement = document.querySelector('[data-cart-subtotal]');
      if (subtotalElement) {
        subtotalElement.textContent = this.formatMoney(cart.total_price);
      }
      
      // Update total
      const totalElement = document.querySelector('[data-cart-total]');
      if (totalElement) {
        totalElement.textContent = this.formatMoney(cart.total_price);
      }
      
      // Update item count in header
      const countElement = document.querySelector('.puremer-cart__count');
      if (countElement) {
        countElement.textContent = `(${cart.item_count})`;
      }
      
      // Update line totals based on variant ID
      cart.items.forEach(item => {
        const itemElement = document.querySelector(`[data-cart-item][data-variant-id="${item.variant_id}"]`);
        if (itemElement) {
          const lineTotalElement = itemElement.querySelector('[data-line-total]');
          if (lineTotalElement) {
            lineTotalElement.textContent = this.formatMoney(item.final_line_price);
          }
          
          // Update quantity input if it exists
          const quantityInput = itemElement.querySelector('[data-quantity-input]');
          if (quantityInput && quantityInput.value != item.quantity) {
            quantityInput.value = item.quantity;
            quantityInput.defaultValue = item.quantity;
          }
        }
      });
      
      // Update cart count badges (header)
      const cartBadges = document.querySelectorAll('[data-cart-count]');
      cartBadges.forEach(badge => {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          badge.classList.add('visible');
        } else {
          badge.classList.remove('visible');
        }
      });

      // Dispatch a global event to notify other integrations (e.g., EasyPoints)
      try {
        const event = new CustomEvent('cart:updated', { detail: { cart } });
        document.dispatchEvent(event);
      } catch (err) {
        // no-op
      }
    },

    // Format money
    formatMoney(cents) {
      // Use Shopify's money format if available
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, theme.moneyFormat || '¥{{ amount_no_decimals }}');
      }
      // Fallback to simple formatting
      return '¥' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // Show loading overlay
    showLoading() {
      if (this.loadingOverlay) {
        this.loadingOverlay.removeAttribute('hidden');
      }
    },

    // Hide loading overlay
    hideLoading() {
      if (this.loadingOverlay) {
        this.loadingOverlay.setAttribute('hidden', '');
      }
    },

    // Show error message
    showError(message) {
      // Create error notification
      const notification = document.createElement('div');
      notification.className = 'puremer-cart-notification puremer-cart-notification--error';
      notification.textContent = message;
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #FEE;
        color: #D44;
        padding: 16px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        z-index: 10000;
        font-family: var(--puremer-font-jp);
        font-size: 14px;
        animation: slideIn 0.3s ease;
      `;
      
      document.body.appendChild(notification);
      
      // Remove after 3 seconds
      setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }
  };

  // Add CSS animations
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    @keyframes slideOut {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
    [data-cart-item] {
      transition: opacity 0.3s ease;
    }
  `;
  document.head.appendChild(style);

  // Add initialization debug
  console.log('PuremerCart script loaded, document state:', document.readyState);
  console.log('Current page template:', document.body ? document.body.dataset.template : 'unknown');
  console.log('Body classes:', document.body ? document.body.className : 'no body');
  console.log('Body ID:', document.body ? document.body.id : 'no body');

  // --- EasyPoints: Theme-side UI sync helpers ---
  function syncAppliedPointsUI() {
    try {
      const appliedContainer = document.getElementById('applied-discount-display');
      const appliedAmountEl = document.getElementById('applied-discount-amount');
      const subtotalAfterWrap = document.getElementById('subtotal-after-discount');
      const subtotalAfterEl = document.getElementById('discounted-subtotal');

      if (!appliedContainer || !appliedAmountEl || !subtotalAfterWrap || !subtotalAfterEl) {
        return;
      }

      const getDiscountPoints = () => {
        try {
          if (window.EasyPoints && typeof window.EasyPoints.getDiscountSession === 'function') {
            return window.EasyPoints.getDiscountSession();
          }
        } catch (_) {}
        return 0;
      };

      const discountPoints = getDiscountPoints();

      if (discountPoints > 0) {
        const opts = (window.EasyPointsCore && EasyPointsCore.Currency && EasyPointsCore.Currency.getFormatOptions && EasyPointsCore.Currency.getFormatOptions()) || { multiplier: 100 };
        const rate = (window.EasyPointsCore && EasyPointsCore.Currency && EasyPointsCore.Currency.getRate && EasyPointsCore.Currency.getRate()) || 1;
        const multiplier = opts.multiplier || 100;
        const discountCents = Math.round(discountPoints * rate * multiplier);

        // Display only numeric part because `-¥` is in the template
        const discountNumber = (discountCents / multiplier).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        appliedAmountEl.textContent = discountNumber;

        // Compute discounted subtotal from data attribute
        const subtotalTarget = document.querySelector('[data-loyal-target="total_price"]');
        const baseSubtotal = subtotalTarget ? parseInt(subtotalTarget.dataset.loyalTotalPrice) : null;
        if (baseSubtotal != null && !isNaN(baseSubtotal)) {
          const discounted = Math.max(0, baseSubtotal - discountCents);
          if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            subtotalAfterEl.textContent = Shopify.formatMoney(discounted, theme.moneyFormat || '¥{{ amount_no_decimals }}');
          } else {
            subtotalAfterEl.textContent = '¥' + (discounted / multiplier).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }

          // Update total (合計) to discounted as well
          const totalEl = document.getElementById('final-total');
          if (totalEl) {
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
              totalEl.textContent = Shopify.formatMoney(discounted, theme.moneyFormat || '¥{{ amount_no_decimals }}');
            } else {
              totalEl.textContent = '¥' + (discounted / multiplier).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        }

        appliedContainer.style.display = '';
        subtotalAfterWrap.style.display = '';
      } else {
        appliedContainer.style.display = 'none';
        subtotalAfterWrap.style.display = 'none';
        appliedAmountEl.textContent = '0';

        // Reset total back to base subtotal when no discount from session
        const subtotalTarget = document.querySelector('[data-loyal-target="total_price"]');
        const totalEl = document.getElementById('final-total');
        if (subtotalTarget && totalEl) {
          const baseSubtotal = parseInt(subtotalTarget.dataset.loyalTotalPrice);
          if (!isNaN(baseSubtotal)) {
            if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
              totalEl.textContent = Shopify.formatMoney(baseSubtotal, theme.moneyFormat || '¥{{ amount_no_decimals }}');
            } else {
              const multiplier = 100;
              totalEl.textContent = '¥' + (baseSubtotal / multiplier).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        }
      }
    } catch (_) {
      // no-op
    }
  }

  // Fallback: detect server-side cart discount when EP session is missing
  async function syncServerDiscountFallback() {
    try {
      if (window.__EP_reset_inflight) return;
      // Do not show fallback if EP cloned subtotal is present (app owns the UI)
      const hasClone = !!document.querySelector('[data-loyal-clone="subtotal"]');
      if (hasClone) return;

      // If EP session knows a discount, normal sync handles UI
      const epSession = (window.EasyPoints && EasyPoints.getDiscountSession && EasyPoints.getDiscountSession()) || 0;
      if (epSession > 0) return;

      const res = await fetch('/cart.json', { headers: { accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const applied = (cart.cart_level_discount_applications || [])
        .reduce((sum, a) => sum + (parseInt(a.total_allocated_amount || 0) || 0), 0);

      const appliedContainer = document.getElementById('applied-discount-display');
      const appliedAmountEl = document.getElementById('applied-discount-amount');
      const subtotalAfterWrap = document.getElementById('subtotal-after-discount');
      const subtotalAfterEl = document.getElementById('discounted-subtotal');

      if (!appliedContainer || !appliedAmountEl || !subtotalAfterWrap || !subtotalAfterEl) return;

      if (applied > 0) {
        const subtotalTarget = document.querySelector('[data-loyal-target="total_price"]');
        const baseSubtotal = subtotalTarget ? parseInt(subtotalTarget.dataset.loyalTotalPrice) : cart.total_price;
        const multiplier = 100; // cents

        const discountNumber = (applied / multiplier).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        appliedAmountEl.textContent = discountNumber;

        const discounted = Math.max(0, baseSubtotal - applied);
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          subtotalAfterEl.textContent = Shopify.formatMoney(discounted, theme.moneyFormat || '¥{{ amount_no_decimals }}');
        } else {
          subtotalAfterEl.textContent = '¥' + (discounted / multiplier).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        appliedContainer.style.display = '';
        subtotalAfterWrap.style.display = '';

        // Hide redeem button and keep reset (read-only state)
        const redeemBtn = document.querySelector('.easy-points-button__redeem');
        if (redeemBtn) redeemBtn.classList.add('easy-points-hide');
      }
    } catch (_) {
      // no-op
    }
  }

  // Reconcile EP session with server-side discount when cart is (re)shown
  async function reconcileCartAndSession() {
    try {
      if (window.__EP_reset_inflight) return;
      window.__EP_reset_inflight = true;

      // Load cart totals
      const res = await fetch('/cart.json', { headers: { accept: 'application/json' } });
      if (!res.ok) { window.__EP_reset_inflight = false; return; }
      const cart = await res.json();

      const original = parseInt(cart.original_total_price || 0);
      const current = parseInt(cart.total_price || 0);
      const delta = Math.max(0, original - current);

      // Currency options (points -> currency)
      const opts = (window.EasyPointsCore && EasyPointsCore.Currency && EasyPointsCore.Currency.getFormatOptions && EasyPointsCore.Currency.getFormatOptions()) || { multiplier: 100 };
      const rate = (window.EasyPointsCore && EasyPointsCore.Currency && EasyPointsCore.Currency.getRate && EasyPointsCore.Currency.getRate()) || 1;
      const multiplier = opts.multiplier || 100;

      const sessionPts = (window.EasyPoints && EasyPoints.getDiscountSession && EasyPoints.getDiscountSession()) || 0;

      if (delta > 0 && sessionPts === 0) {
        // Recover points from currency delta and set EP session
        const recoveredPoints = Math.max(0, Math.round(delta / (rate * multiplier)));

        // Ensure form exists then hydrate inputs
        try { window.EasyPoints && EasyPoints.Cart && EasyPoints.Cart.setRedemptionForm && EasyPoints.Cart.setRedemptionForm(); } catch(_) {}
        try { window.EasyPoints && EasyPoints.Register && EasyPoints.Register.run && EasyPoints.Register.run(); } catch(_) {}

        try {
          const visibleInput = document.getElementById('redemption-point-value');
          if (visibleInput) visibleInput.value = recoveredPoints;
          const hiddenInput = document.querySelector('input[name="coupon[point_value]"]');
          if (hiddenInput) hiddenInput.value = recoveredPoints;
        } catch(_) {}

        try { sessionStorage.setItem('appliedDiscount', String(recoveredPoints)); } catch(_) {}

        // Let EP apply discount UI based on recovered session
        try { window.EasyPoints && EasyPoints.applyDiscount && EasyPoints.applyDiscount(); } catch(_) {}
      } else if (delta === 0 && sessionPts > 0) {
        // Session says applied but server側は未適用 → EPセッションを掃除
        try { window.EasyPoints && EasyPoints.reset && EasyPoints.reset({}); } catch(_) {}
      }

      setTimeout(syncAppliedPointsUI, 0);
      window.__EP_reset_inflight = false;
    } catch(_) {
      window.__EP_reset_inflight = false;
    }
  }

  // Auto redeem when input value > 0 (no form submit yet)
  function attachAutoRedeem() {
    try {
      const inputs = document.querySelectorAll('.easy-points-form__input input');
      inputs.forEach((el) => {
        if (el.dataset.autoRedeemBound === '1') return;
        el.dataset.autoRedeemBound = '1';

        let t;
        const handler = () => {
          clearTimeout(t);
          t = setTimeout(() => {
            const val = parseInt((el.value || '').toString().replace(/[^\d]/g, '')) || 0;
            if (val > 0 && window.EasyPoints && EasyPoints.Form && typeof EasyPoints.Form.redeem === 'function') {
              try {
                EasyPoints.Form.redeem({ points: val });
                EasyPoints.applyDiscount && EasyPoints.applyDiscount();
              } catch (_) {}
              setTimeout(syncAppliedPointsUI, 0);
            }
          }, 250);
        };

        el.addEventListener('input', handler);
        el.addEventListener('change', handler);
      });
    } catch (_) {}
  }

  // Guard checkout clicks so EasyPoints coupon API fires exactly once
  function attachCheckoutGuard() {
    try {
      if (window.__EP_checkout_guard_attached) return;
      const checkoutBtn = document.querySelector('[type="submit"][name="checkout"]');
      if (!checkoutBtn) return;
      window.__EP_checkout_guard_attached = true;

      checkoutBtn.addEventListener('click', (e) => {
        try {
          // Allow pass-through if EasyPoints already marked ready (second programmatic click)
          if (window.EasyPoints && EasyPoints.Register && EasyPoints.Register.submissionReady) {
            return; // let native submit proceed
          }

          // If EasyPoints is present, intercept once and call its handler exactly once
          if (window.EasyPoints && EasyPoints.Register && typeof EasyPoints.Register.onClickSetCoupon === 'function') {
            if (window.__EP_checkout_lock) {
              e.preventDefault();
              e.stopImmediatePropagation();
              return;
            }

            window.__EP_checkout_lock = true;
            e.preventDefault();
            e.stopImmediatePropagation();

            try {
              EasyPoints.Register.onClickSetCoupon(e);
            } finally {
              // unlock shortly; the next programmatic click should pass through because submissionReady=true
              setTimeout(() => { window.__EP_checkout_lock = false; }, 500);
            }
          }
        } catch (_) {}
      }, true); // capture to preempt duplicate listeners added by app
    } catch (_) {}
  }
  
  // Test if we're on the right page
  const cartSection = document.querySelector('.puremer-cart');
  console.log('Cart section found:', !!cartSection);
  const cartForm = document.getElementById('cart-form');
  console.log('Cart form found:', !!cartForm);
  const quantityContainers = document.querySelectorAll('.puremer-quantity');
  console.log('Quantity containers found:', quantityContainers.length);
  console.log('All elements with puremer class:', document.querySelectorAll('[class*="puremer"]').length);
  
  // Initialize when DOM is ready
  function initCart() {
    console.log('Attempting to initialize PuremerCart...');
    const cartSection = document.querySelector('.puremer-cart');
    const cartForm = document.getElementById('cart-form');
    
    if (!cartSection) {
      console.log('Cart section not found, skipping initialization');
      return false;
    }
    
    if (!cartForm) {
      console.log('Cart form not found, skipping initialization');
      return false;
    }
    
    PuremerCart.init();
    return true;
  }
  
  // Multiple initialization attempts
  let initializationAttempts = 0;
  const maxAttempts = 5;
  
  function tryInitialize() {
    initializationAttempts++;
    console.log(`Initialization attempt ${initializationAttempts}/${maxAttempts}`);
    
    if (initCart() || initializationAttempts >= maxAttempts) {
      console.log('Initialization completed or max attempts reached');
      return;
    }
    
    // Try again after a short delay
    setTimeout(tryInitialize, 200);
  }
  
  if (document.readyState === 'loading') {
    console.log('Document still loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', function() {
      tryInitialize();
      // Initial sync in case discount already applied
      setTimeout(syncAppliedPointsUI, 0);
      setTimeout(attachCheckoutGuard, 0);
      // Reconcile UI with server-side discount when cart is shown
      setTimeout(reconcileCartAndSession, 0);
    });
  } else {
    console.log('Document already loaded, initializing immediately...');
    tryInitialize();
    setTimeout(syncAppliedPointsUI, 0);
    setTimeout(attachCheckoutGuard, 0);
    setTimeout(reconcileCartAndSession, 0);
  }

  // Export for global access if needed
  window.PuremerCart = PuremerCart;

  // EasyPoints integration: reconcile on bfcache restore
  window.addEventListener('pageshow', (e) => {
    try {
      if (e && e.persisted) {
        reconcileCartAndSession();
      }
      // Safari/iOSのbfcache対策: DOM安定後に複数回再同期
      setTimeout(syncAppliedPointsUI, 0);
      setTimeout(syncServerDiscountFallback, 0);
      setTimeout(syncAppliedPointsUI, 120);
      setTimeout(syncServerDiscountFallback, 140);
    } catch (err) {
      // no-op
    }
  });

  // EasyPoints integration: sync UI after cart updates
  document.addEventListener('cart:updated', () => {
    try {
      // Do not reset on quantity changes; only refresh UI
      setTimeout(syncAppliedPointsUI, 0);
      setTimeout(syncServerDiscountFallback, 0);
    } catch (err) {
      // no-op
    }
  });

  // Also handle when tab becomes visible again (iOS/Safari back behavior)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      try {
        reconcileCartAndSession();
      } finally {
        setTimeout(syncAppliedPointsUI, 0);
        setTimeout(syncServerDiscountFallback, 0);
        setTimeout(syncAppliedPointsUI, 120);
        setTimeout(syncServerDiscountFallback, 140);
      }
    }
  });

  // Sync after clicking redeem/reset buttons
  document.addEventListener('click', (e) => {
    const redeem = e.target && e.target.closest && e.target.closest('.easy-points-button__redeem');
    const reset = e.target && e.target.closest && e.target.closest('.easy-points-button__reset');
    if (redeem || reset) {
      setTimeout(syncAppliedPointsUI, 50);
    }
  }, true);

})();
